import React from 'react';

import { COLOR_ROLES } from './color-roles';
import BaseTable from './components/base-table';

/**
 * __Color roles table__
 *
 * A color roles table describes the intention behind the color.
 *
 */
const ColorRolesTable = (): React.JSX.Element => (
	<BaseTable tableData={COLOR_ROLES} categoryName="Role" />
);

export default ColorRolesTable;
